import { Controller } from "@hotwired/stimulus"

// Reusable colour field — drop it on any form group with preset swatches, a native
// colour input and/or a manual hex field. All three write into the bound input and
// expose the value as a CSS variable on the controller element, so descendants
// (e.g. a live preview) can react. Configure the variable name via
// data-color-picker-variable-value (default "--color").
//
// Markup:
//   %div{data: {controller: 'color-picker', 'color-picker-variable-value': '--cat-color'}}
//     %button{data: {action: 'color-picker#select', color: '#832121'}}
//     %input{type: 'color', data: {action: 'color-picker#pick'}}
//     = f.input_field :color, data: {'color-picker-target': 'input', action: 'color-picker#type'}
export default class extends Controller {
  static targets = ["input"]
  static values = { variable: { type: String, default: "--color" } }

  connect() {
    if (this.hasInputTarget) this.expose(this.inputTarget.value)
  }

  select(event) { this.set(event.currentTarget.dataset.color) }
  pick(event)   { this.set(event.currentTarget.value) }
  type(event)   { this.expose(event.currentTarget.value) }

  set(value) {
    if (!value) return
    if (this.hasInputTarget) {
      this.inputTarget.value = value
      this.inputTarget.dispatchEvent(new Event("input", { bubbles: true }))
    }
    this.expose(value)
  }

  expose(value) {
    if (value) this.element.style.setProperty(this.variableValue, value)
  }
}
